<mat-card class="login-form">
    <mat-card-header>
        <mat-card-title>
            <h2 *ngIf="!isExpired">
                {{'auth.changePassword.title.shortLabel' | translate}}
                <app-tooltip text="{{'auth.changePassword.title.summary' | translate}}"></app-tooltip>
            </h2>
            <h2 *ngIf="isExpired">
                {{'auth.changePassword.linkExpired.shortLabel' | translate}}
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" *ngIf="!isExpired; else expiredMessage">
            <mat-form-field *ngIf="!isWelcome">
                <mat-label>{{'auth.changePassword.currentPassword.label.shortLabel' | translate}}</mat-label>
                <input type="password" matInput formControlName="currentPassword">
                <mat-error>{{'auth.changePassword.currentPassword.errorMessage.summary' | translate}}</mat-error>
                <mat-hint align="end"><a routerLink="/forgot-password">{{'auth.forgotPassword.fullLabel' | translate}}</a></mat-hint>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'auth.changePassword.newPassword.label.shortLabel' | translate}}</mat-label>
                <input type="password" matInput formControlName="newPassword">
                <mat-error>{{'auth.changePassword.newPassword.errorMessage.summary' | translate}}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'auth.changePassword.confirmPassword.label.shortLabel' | translate}}</mat-label>
                <input type="password" matInput
                    formControlName="confirmPassword"
                    [errorStateMatcher]="confirmValidMatcher">
                <mat-error>{{'auth.changePassword.confirmPassword.errorMessage.summary' | translate}}</mat-error>
            </mat-form-field>
            <mat-card-title *ngIf="isNewUser">
                <h2 class="title">
                    {{'auth.newsletter.title.fullLabel' | translate}}
                </h2>
            </mat-card-title>
            <div class="item"><mat-checkbox *ngIf="isNewUser" formControlName="isSubscribedNewsletter">
                {{'auth.newsletter.subscription.summary' | translate}}
            </mat-checkbox></div>
            <button *ngIf="!isLoading" type="submit" mat-raised-button color="accent" [disabled]="passwordForm.invalid">
                {{'auth.submit.shortLabel' | translate}}
            </button>
        </form>
    </mat-card-content>
    <mat-card-content>
        <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent"></mat-spinner>
        <ng-template #expiredMessage>
            <div class="expired-message" [innerHTML]="'auth.changePassword.linkExpired.detail' |translate"></div>
        </ng-template>
    </mat-card-content>
</mat-card>
